const DeviceSubscriptions = () => import("Modules/configuration/device_subscriptions/views/DeviceSubscriptions");

export default {
	children: [
		{
			path: "configuration/device-subscriptions",
			name: "device_subscriptions",
			component: DeviceSubscriptions,
			meta: {
				requiresAuth: true,
				title: "lang.device_subscriptions",
				restrict_by_login_type: ["customer_support", "administrator", "developer", "employee", "distributor"],
				restrict_by_permission: ["subscriptions.read"],
				tabTitle: "Device Subscriptions",
			},
		},
	],
};
